<template>
  <v-snackbar v-model="showModal" color="warning" right :timeout="-1">
    <div class="d-flex justify-space-between align-center">
      <div>Update is available. <br /></div>
      <v-btn outlined small @click="update()" :loading="updating">
        Update
      </v-btn>
    </div>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
      latestVersion: null,
      updating: false,
      registration: null,
    };
  },
  mounted() {
    if (process.env.NODE_ENV === "production") {
      document.addEventListener("swUpdated", this.updateAvailable, {
        once: true,
      });
    }
  },
  methods: {
    getCurrentVersion() {
      let currentVersion = this.$store.state.config.appVersion;
      currentVersion = currentVersion.replace("v", "");
      currentVersion = currentVersion.split("-")[0];

      return currentVersion;
    },

    updateAvailable(event) {
      this.registration = event.detail;
      this.showModal = true;
    },

    update() {
      this.updating = true;

      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) {
        window.location.reload();
      }

      // Send message to SW to skip the waiting and activate the new SW
      this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
      window.location.reload();
    },
  },
};
</script>

<style>
</style>